module.exports = __webpack_public_path__ + "img/71.406c4336.png";